import ChangeToken from "../components/ChangeToken";

const ChangeTokenPage = () => {
  document.title = "Изменить токен | Кампания из Эвенглена";
  return <ChangeToken />;
};

export default ChangeTokenPage;
